import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import UserProfile from './UserProfile/UserProfile';
import SupportModal from '../Support/SupportModal';
import ReviewRatingModal from './ReviewRating/ReviewRatingModal';
import { getProfileStatus } from '../../../services/authService'; // <-- you’ll define this API function
import { useOption } from '../../../context/OptionContext';
import { useStatus } from '../../../context/StatusContext';
import { Price } from '../../StaticPages';
import { UpgradProvider } from '../../../context/PermissionUpgradContext';
import { getCurrentPlan } from '../../../services/billing'
import SpinnerLoader from '../../StaticPages/Pages/SpinnerLoader/Loader.jsx'
import PendingPlanSection from '../../StaticPages/Pages/Price/PendingPlanPage.jsx';
import PackageSummaryModal from './Razorpay/PackageSummaryModal.jsx';
import MarketplaceModalNew from './MarketPlaceModal/MarketPlaceModalNew.jsx';
const DashboardLayout = () => {
  const location = useLocation();
  const { selectedOption } = useOption();
  const navigate = useNavigate();
  const { setstatusValues } = useStatus();
  const [showReviewModal, setShowReviewModal] = useState(false);
  const needMarketplaceAccount = JSON.parse(localStorage.getItem("need_marketplace_account"));
  const accountDisabled = JSON.parse(localStorage.getItem("block-user"));
  const isProfile = location.pathname === "/profile";
  const [showAddReview, setShowAddReview] = useState(false);
  const [isLoading, setIsLoading] = useState({
    isCurrentPlan: true,
    isProfileStatus: true,
    isMarketPlaceAcc: true
  })

  const [isSubscription, setIsSubscription] = useState({
    isActive: false,
    isPending: false,
    isCancelled: false
  })

  const [currentPlanDetails, setCurrentPlanDetails] = useState(null)
  const handleOpen = () => setShowAddReview(true);
  const handleClose = () => setShowAddReview(false);
  const allowSectionUrlForSuspend = [
    "/suggestion-portal",
    "/referral",
    "/billing-section",
    "/ticket"
  ];

  useEffect(() => {
    fetchCurrentPlanDetails()
  }, [])


  useEffect(() => {
    document.addEventListener('contextmenu', (e) => e.preventDefault());
    document.addEventListener('selectstart', (e) => e.preventDefault());

    document.addEventListener('keydown', (e) => {
      if ((e.ctrlKey || e.metaKey) && ['c', 'x', 'a', 's', 'p'].includes(e.key.toLowerCase())) {
        e.preventDefault();
      }

      if (e.key === 'PrintScreen') {
        e.preventDefault();
      }
    });

    document.addEventListener('copy', (e) => {
      e.preventDefault();
    });

  }, []);

  const isPlanSuspended = (subscription) =>
    subscription?.status === 'suspended' && subscription?.recurring_payment;

  const isAllowedSuspendPath = (path) => {
    return allowSectionUrlForSuspend.some((allowed) => path.startsWith(allowed));
  };

  useEffect(() => {
    if (!isLoading?.isCurrentPlan && isPlanSuspended(currentPlanDetails?.subscription)) {
      if (!isAllowedSuspendPath(location.pathname)) {
        navigate("/billing-section", { replace: true });
      }
    }
  }, [location.pathname, currentPlanDetails, isLoading?.isCurrentPlan]);


  const fetchCurrentPlanDetails = async () => {
    try {
      const apiRes = await getCurrentPlan();
      const subscription = apiRes?.data?.data?.attributes?.subscription;
      const subscriptionStatus = subscription?.status;
      setCurrentPlanDetails(apiRes?.data?.data?.attributes);

      if (subscriptionStatus === 'active' || isPlanSuspended(subscription)) {
        setIsSubscription({ isActive: true })
      }
      else if (subscriptionStatus === "pending_payment" || (subscriptionStatus === "suspended" && !subscription?.recurring_payment)) {
        setIsSubscription({ isPending: true })
      }
      else {
        setIsSubscription({ isCancelled: true })
      }
    }
    catch (err) {
      console.error('Failed to fetch current plan details : ', err)
    }
    finally {
      setIsLoading((prev) => ({
        ...prev,
        isCurrentPlan: false
      }))
    }
  }

  useEffect(() => {
    const refreshHandler = () => {
      fetchCurrentPlanDetails();
    };
    window.addEventListener("refresh-page", refreshHandler);
    return () => window.removeEventListener("refresh-page", refreshHandler);
  }, []);

  useEffect(() => {
    if (!selectedOption) {
      setIsLoading((prev) => ({
        ...prev,
        isMarketPlaceAcc: false
      }))
      return;
    }

    // const { id: marketplaceId } = selectedOption;

    if (!selectedOption?.id) {
      setIsLoading((prev) => ({
        ...prev,
        isMarketPlaceAcc: false
      }))
      return;
    }


    // ----- set attribute in the html tag with the help of local storage stored theme

    document.documentElement.setAttribute("data-theme", localStorage.getItem('theme'));

    fetchStatus(selectedOption?.id);
    const intervalId = setInterval(fetchStatus, 600000);

    return () => clearInterval(intervalId);
  }, [selectedOption?.id]);

  const fetchStatus = async (accountId) => {
    try {
      const response = await getProfileStatus(accountId);

      if (response?.data?.review === true) {
        setShowReviewModal(true);
      }

      if ('dashboard_ready' in response.data) {
        localStorage.setItem('dashboard-ready', response.data.dashboard_ready);
        setstatusValues((prev) => ({
          ...prev,
          dashboardReady: response.data.dashboard_ready
        }))
      }

      if ('min_date' in response.data) {
        localStorage.setItem('min_date', response.data.min_date);
        setstatusValues((prev) => ({
          ...prev,
          minDate: response.data.min_date
        }))
      }

      if ('max_date' in response.data) {
        localStorage.setItem('max_date', response.data.max_date);
        setstatusValues((prev) => ({
          ...prev,
          maxDate: response.data.max_date
        }))
      }

      if ('ads' in response.data) {
        localStorage.setItem('show-ads', response.data.ads);
        setstatusValues((prev) => ({
          ...prev,
          showAds: response.data.ads
        }))
      }

    } catch (err) {
      console.error("Failed to check dashboard status:", err);
    } finally {
      setIsLoading((prev) => ({
        ...prev,
        isProfileStatus: false
      }))
    }
  };

  useEffect(() => {
    if (needMarketplaceAccount || accountDisabled || isSubscription?.isPending || isSubscription?.isCancelled) {
      // Wait until next tick to ensure DOM is ready
      const timer = setTimeout(() => {
        const main = document.getElementById('main');
        const header = document.querySelector('.header');
        if (main) main.style.marginLeft = '0';
        if (header) header.style.marginLeft = '0';
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [needMarketplaceAccount, accountDisabled, isSubscription]);

  if (isLoading?.isCurrentPlan) {
    return <>
      <SpinnerLoader />
    </>
  }

  if (accountDisabled === true) {
    return (

      <div className="main-content">
        <Header />
        <main id="main" className="main">
          <div className="disabled-account-wrapper d-flex justify-content-center align-items-center" style={{ height: "100vh", flexDirection: "column" }}>
            <div className="text-center p-4 rounded disable-account-card" style={{ maxWidth: "500px" }}>
              <i className="bi bi-shield-exclamation text-danger" style={{ fontSize: "4rem" }}></i>
              <h2 className="mt-3 custom-text-dark">Access Denied</h2>
              <p className="custom-text-muted">
                Your account has been <strong>disabled</strong>. You cannot access the dashboard at the moment.
              </p>
              <button className="btn btn-primary mt-3" data-bs-toggle="modal" data-bs-target="#supportModal">
                Contact Support
              </button>
              <div className="mt-4">
                <small className="custom-text-muted">Still need help? Reach out to our support team for assistance.</small>
              </div>
            </div>
            <SupportModal />
          </div>
        </main>
      </div>
    );
  }

  if (isSubscription?.isCancelled) {
    return (
      <div className="main-content">
        <Header isLogo={isSubscription?.isCancelled} />
        {isProfile ? (
          <main id="main" className="main mainDashboard">
            <UserProfile />
          </main>
        ) : (
          <main id="main" className="main select-plan" style={{ marginTop: '40px' }}>
            <Price />
          </main>
        )}
      </div>
    )
  }

  if (isSubscription?.isPending) {
    return (
      <div className="main-content">
        <Header />
        {isProfile ? (
          <main id="main" className="main mainDashboard">
            <UserProfile />
          </main>
        ) : (
          <main id="main" className="main" style={{ marginTop: '40px' }}>
            <PendingPlanSection currentPlan={currentPlanDetails} />
          </main>
        )}
      </div>
    )
  }

  return (<>
    <UpgradProvider>
      <PackageSummaryModal
      currentPlan={currentPlanDetails}
      packageType={'upgrade'} />
      {showAddReview && <ReviewRatingModal onClose={handleClose} />}
      {isLoading?.isCurrentPlan === false && (
        <div className="dashboard-wrapper">
          {needMarketplaceAccount !== true ? (
            <>
              <Sidebar handleOpen={handleOpen} disableAll={isPlanSuspended(currentPlanDetails?.subscription)} />

              <div className="main-content">
                <Header />
                <main id="main" className="main mainDashboard position-relative">
                  {/* Show Review Modal */}
                  {showReviewModal && (
                    <ReviewRatingModal
                      onClose={() => {
                        setShowReviewModal(false);
                      }}
                    />
                  )}
                  <Outlet />
                </main>
              </div>
            </>
          ) : (
            <>
              <div className="main-content">
                <Header />
                {isProfile ? (
                  <main id="main" className="main mainDashboard">
                    <UserProfile />
                  </main>
                ) : (
                  <main id="main" className="main">
                    <MarketplaceModalNew />
                  </main>
                )}
              </div>
            </>
          )}

          {/* Floating Icon */}
          <i
            className="bi bi-question-circle floating-icon"
            data-bs-toggle="modal"
            data-bs-target="#supportModal"
            title="Support"
            style={{ cursor: 'pointer', width: "3rem", height: "3rem" }}
          ></i>
          <SupportModal />
        </div>
      )}
    </UpgradProvider>
  </>
  );
};

export default DashboardLayout;